import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatDateRange(startDate, endDate) {
  if (!startDate) return '';
  const s = new Date(startDate);
  if (!endDate) return formatDate(startDate);
  const e = new Date(endDate);
  const sameDay = s.getFullYear() === e.getFullYear() && s.getMonth() === e.getMonth() && s.getDate() === e.getDate();
  if (sameDay) {
    return `${s.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}, ${s.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })} - ${e.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}`;
  }
  return `${s.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })} — ${e.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}`;
}

export function formatDateTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatCurrency(amount, currency = 'EUR') {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency,
  }).format(amount);
}

export function getStatusLabel(status) {
  const labels = {
    REGISTERED_PENDING_PAYMENT: 'Pendiente de pago',
    PAID_CONFIRMED: 'Pagado',
    CONFIRMED_FREE: 'Confirmado',
    CANCELLED: 'Cancelado',
  };
  return labels[status] || status;
}

export function getStatusColor(status) {
  const colors = {
    REGISTERED_PENDING_PAYMENT: 'bg-amber-100 text-amber-800',
    PAID_CONFIRMED: 'bg-blue-100 text-blue-800',
    CONFIRMED_FREE: 'bg-green-100 text-green-800',
    CANCELLED: 'bg-red-100 text-red-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}

export function getPresenceLabel(presence) {
  return presence === 'DENTRO' ? 'Dentro' : 'Fuera';
}

export function getPresenceColor(presence) {
  return presence === 'DENTRO' 
    ? 'bg-emerald-500 text-white' 
    : 'bg-slate-400 text-white';
}

export function downloadJSON(data, filename) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadCSV(data, filename) {
  if (!data || data.length === 0) return;
  
  const headers = Object.keys(data[0]);
  const csvRows = [
    headers.join(','),
    ...data.map(row => 
      headers.map(header => {
        let cell = row[header] ?? '';
        if (typeof cell === 'string' && (cell.includes(',') || cell.includes('"'))) {
          cell = `"${cell.replace(/"/g, '""')}"`;
        }
        return cell;
      }).join(',')
    )
  ];
  
  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
